import { rootState } from '@core-interface'

export const getPatientProfileDetailsFromReducer = (state:rootState) => state?.patientProfileReducer?.patientProfileData;
export const getDentistListFromReducer = (state:rootState) => state?.patientProfileReducer?.dentistList;
export const getDentistListLoadingStatusFromReducer = (state:rootState) => state?.patientProfileReducer?.getDentistListLoading;
export const getUpdateDentistDataFromReducer = (state:rootState) => state?.patientProfileReducer?.updateDentistLoading;
